import { t } from '@lingui/core/macro';
import { formatDateTime } from '@/common/utils/formatDateTime';

const HOUR_MS = 60 * 60_000;
const DAY_MS = 24 * HOUR_MS;

function spanLabel(spanMs: number): string {
  if (spanMs >= 2 * DAY_MS) {
    const days = Math.round(spanMs / DAY_MS);
    return t`${days} d`;
  }
  const hours = Math.round(spanMs / HOUR_MS);
  return t`${hours} h`;
}

/** `d.M.yyyy, HH:mm – d.M.yyyy, HH:mm · 24 h`-style summary for the selected range. */
export function formatRangeSummary(from: Date, to: Date): string {
  const span = spanLabel(to.getTime() - from.getTime());
  return `${formatDateTime(from, 'dateTimeShort')} – ${formatDateTime(to, 'dateTimeShort')} · ${span}`;
}
